import { PerspectiveCamera } from "@react-three/drei"

export default function ContactProps({camPosition=[0,9,40]}) {
    return (
        <>
            <PerspectiveCamera
                position={camPosition}
                fov={17.5}
                near={1}
                far={200}
                makeDefault
                onUpdate={(self) => self.updateProjectionMatrix()}
            />
            <color attach="background" args={["#482BFF"]} />
            {/* <ambientLight intensity={0.4} /> */}
            {/* <directionalLight position={[3.3, 1.0, 4.4]} castShadow intensity={Math.PI * 2} /> */}
        </>

    )
}